import { useSelector } from 'react-redux';
import { CustomModal } from 'shared/components/CustomModal';
import { useAppDispatch } from 'shared/hooks';
import { setModalContent } from 'shared/slices';
import { selectModalContent } from 'shared/selectors/modal';
import { AuthenticationContainer } from '../AuthenticationContainer';
import { ALL_DOORS } from 'shared/constants/doors';
import { AdventQuizContainer } from '../AdventQuizContainer';
import { selectUser } from 'shared/selectors/user';
import { EUserStatus } from 'shared/types/user';

export const ModalContainer: React.FC = () => {
  const content = useSelector(selectModalContent);

  const { status } = useSelector(selectUser);

  const isLoading = status === EUserStatus.Loading;

  const dispatch = useAppDispatch();

  const handleCloseModal = () => {
    dispatch(setModalContent(null));
  };

  let modalContent: JSX.Element | null = null;

  if (content?.type === 'door') {
    const door = ALL_DOORS.find(d => d.id === content.doorId);
    if (door?.Content) {
      const DoorContent = door.Content;
      modalContent = (
        <DoorContent
          image={content.props.image}
          isLoading={isLoading}
          title={content.props.title}
          doorId={content.doorId}
        />
      );
    }
  } else if (content?.type === 'authentication') {
    modalContent = <AuthenticationContainer />;
  } else if (content?.type === 'quiz') {
    modalContent = <AdventQuizContainer />;
  }

  if (!modalContent) {
    return null;
  }

  return (
    <CustomModal open onClose={handleCloseModal}>
      {modalContent}
    </CustomModal>
  );
};
